"use client"

import { useQuery } from "@tanstack/react-query"

import { useAuth } from "@/hooks/use-auth"
import { getQueryTenantId } from "@/lib/auth/query-tenant-id"
import type { DeliveryPiiRetentionPolicy } from "@/lib/deliveries/pii-retention-config"
import { getDeliveryPiiRetentionPolicyAction } from "@/server-actions/delivery-retention"

export const deliveryPiiRetentionQueryKey = (tenantId: string) =>
  ["delivery-retention", tenantId] as const

export function useDeliveryPiiRetentionPolicyQuery() {
  const { user, isAuthenticated } = useAuth()
  const tenantId = getQueryTenantId(user)

  return useQuery<DeliveryPiiRetentionPolicy>({
    queryKey: deliveryPiiRetentionQueryKey(tenantId),
    enabled: isAuthenticated,
    queryFn: async () => {
      const result = await getDeliveryPiiRetentionPolicyAction({})
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
  })
}
